<template>
    <div>
        <transaction-filter :action="filterAction" :query="query" form_id="user-filter"></transaction-filter>
        <transactions-statistics @updateReport="updateReport($event)"></transactions-statistics>
        <kt-datatable v-if="user" v-bind="datatableProps" ref="datatable"></kt-datatable>
    </div>
</template>

<script>
import $ from 'jquery'
import { ApiUrl } from '@/common/api.service'
import columns from './../datatable/transaction-columns'
import { AuthorizationHeader } from '@/common/jwt.service'
import { mapGetters } from 'vuex'
import transactionStatistics from './transactions-statistics'
import transactionFilter from '../../transaction/components/admin-transaction-filter'
import actionsColumn from "../../transaction/components/starshop-action.vue";

export default {
    components: {
        'transactions-statistics': transactionStatistics,
        transactionFilter,
    },
    data() {
        return {
            query: {
                user_id: this.$route.params.hashid,
            }
        }
    },
    methods: {
        updateReport(event) {
            this.filterAction(event, event)
        },
        filterAction(e, query) {
            this.query = query;
            this.query.user_id = this.$route.params.hashid;
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
            if (this.$can('read', 'transaction')) {
                this.$store.dispatch('transaction/fetchAdminStarshopStatistics', this.query);
            } else {
                this.$store.dispatch('transaction/fetchStarshopStatistics', this.query);
            }
        },
    },
    mounted() {
        if (this.$can('read', 'transaction')) {
            this.$store.dispatch('transaction/fetchAdminStarshopStatistics', this.query);
        } else {
            this.$store.dispatch('transaction/fetchStarshopStatistics', this.query);
        }
    },
    computed: {
        ...mapGetters('user', [
            'user', 'status'
        ]),
        datatableProps() {
            return {
                withPanel: false,
                id: "user_transaction_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.starshopPath('admin/transaction'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: (res) => {
                                return res.data.data
                            },
                            params: {
                                user_id: this.user.id,
                                query: this.query
                            },
                        },
                    },
                    pageSize: 15,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },

                pagination: false,
                sortable: true,
                columns: columns,
                actions: actionsColumn
            }
        }
    },
}
</script>

<style>

</style>